/**
 * Configuração LOCAL do tablet (por dispositivo), no localStorage: apenas a mesa
 * onde o aparelho está fixo. A tela que edita isto fica atrás do PIN (ver
 * components/config-tablet.tsx).
 *
 * A impressora do "chamar garçom" NÃO mora aqui: ela é da LOJA. Não importa de
 * qual tablet o cliente chamou, o chamado tem que sair na mesma impressora do
 * salão — diferente do totem e do totem de checkout, que têm impressora própria
 * acoplada e por isso a escolhem no próprio aparelho.
 */
const KEY = 'cardapio-sischef:tablet-config';

export interface TabletConfig {
  /** Número/identificação da mesa onde o tablet está fixo. */
  mesa: string;
}

const VAZIO: TabletConfig = { mesa: '' };

export function getTabletConfig(): TabletConfig {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...VAZIO };
    const obj = JSON.parse(raw) as Partial<TabletConfig>;
    return { mesa: obj.mesa ?? '' };
  } catch {
    return { ...VAZIO };
  }
}

export function setTabletConfig(cfg: TabletConfig): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ mesa: cfg.mesa.trim() }));
  } catch {
    /* localStorage indisponível — ignora */
  }
}

/** A mesa é obrigatória pro tablet operar. */
export function tabletConfigurado(cfg: TabletConfig = getTabletConfig()): boolean {
  return cfg.mesa.trim().length > 0;
}
